import { request } from '../../utils/index'

// TODO (noahlaux): This file is subject to become multiple exports
// eslint-disable-next-line import/prefer-default-export
export const fetchCountries = () => {
  return request({
    url: '/api/utility/countries',
    method: 'GET',
  })
}
